import {
  Badge,
  Box,
  Button,
  Card,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  Drawer,
  IconButton,
  InputAdornment,
  LinearProgress,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popover,
  Popper,
  Skeleton,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ColDef } from "ag-grid-community";
import { useParams } from "react-router-dom";
import React from "react";
import DetailsFlyout from "./Details-Flyout";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import AssetsFlyout from "./Assets-Flyout";
import Compliance from "./Compliance-flyout";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { setButtonSelected, setSelectedRowID, setTabSelected } from "./TabSelection-slice";
import Exclamation from "../../../../assets/Exclamation.png";
import Pencil_Blue from "../../../../assets/baseVersion/Pencil_Blue.svg";
import Pencil_Light_img from "../../../../assets/baseVersion/Pencil_Light_img.svg";
import True from "../../../../assets/baseVersion/True_img.svg";
import False from "../../../../assets/baseVersion/False_img.svg";
import Not_Applicable from "../../../../assets/baseVersion/NotApplicable.svg";
import SearchIcon from "@mui/icons-material/Search";
import Plus_Blue_img from "../../../../assets/baseVersion/Plus_Blue_img.svg";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import axiosInstance from "../../../../axios/axios";
import AgGridTable from "../../../../components/table/AgGridTable";
//import csiLogo from '../../../../assets/cis.png';
import csiLogo from "../../../../assets/cis_light.svg";
import nistLogo from "../../../../assets/nist.svg";
import nist_dark from "../../../../assets/nist_dark.svg";
import spark_dark from "../../../../assets/spark_dark.svg";
import cis_dark from "../../../../assets/cis_dark.svg";
import sparkLogo from "../../../../assets/Spark-text.svg";
import customTemplateLogo from "../../../../assets/custom_template_logo.svg";
import Logoutput from "./Logoutput";
import { setEdit } from "../MyScanTable_Details_slice";
import eventEmitter from "../../../../components/utils/eventEmitter";
import AcceptedRisk_False from "../../../../assets/baseVersion/AcceptedRisk_False.svg";
import LogoutputManual from "./LogoutPutManual";
import WhiteTooltip from "../../../../components/WhiteTooltip";
import { END_POINTS } from "../../../../shared";

type ScanFilterDevice = {
  device_id: string;
  hostname: string;
  vendor: string;
  model: string;
  device_type: string;
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface ScanDetailsProps {
  scanSummaryId?: string;
}

const ScanDetails: React.FC<ScanDetailsProps> = ({ scanSummaryId }) => {
  const { scan_uuid: paramScanUuid } = useParams<{ scan_uuid: string }>();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();

  const { status: reduxStatus, scanTime: reduxScanTime, scanType: reduxScanType, onprem_posture_id: reduxPostureId, ScanDetails: myScanDetailsList } = useSelector(
    (state: RootState) => state.MyScanDetails
  );

  const queryScanSummaryId = searchParams.get("scan_summary_id") || undefined;
  const scan_summary_id = useMemo(() => {
    return (
      queryScanSummaryId ||
      scanSummaryId ||
      reduxPostureId ||
      paramScanUuid
    );
  }, [queryScanSummaryId, scanSummaryId, reduxPostureId, paramScanUuid]);

  const initialDeviceIds = useMemo(() => {
    const fromQueryMulti = searchParams.get("device_ids");
    const fromQuerySingle =
      searchParams.get("device_id") || searchParams.get("scan_device_id");
    const fromState = (location.state as any)?.deviceIds ??
      (location.state as any)?.device_id ??
      (location.state as any)?.scan_device_id;

    const ids: string[] = [];
    if (fromQueryMulti) {
      ids.push(
        ...fromQueryMulti
          .split(",")
          .map((id) => id.trim())
          .filter(Boolean)
      );
    }
    if (fromQuerySingle) {
      ids.push(String(fromQuerySingle).trim());
    }
    if (Array.isArray(fromState)) {
      ids.push(...fromState.map((id) => String(id).trim()).filter(Boolean));
    } else if (fromState) {
      ids.push(String(fromState).trim());
    }
    return [...new Set(ids.filter(Boolean))];
  }, [searchParams, location.state]);

  const scan_uuid = paramScanUuid;
  const initialFilterAppliedRef = useRef(false);

  const [isRowClick, setIsRowClick] = useState(false);
  const [rowData, setRowData] = useState<any[]>([]);
  const [selectedRow, setSelectedRow] = useState<any | null>(null);
  console.log(selectedRow, "selectedRowselectedRow");

  const [headerResponse, setHeaderResponse] = useState<any>(null);
  const [isHeaderLoading, setIsHeaderLoading] = useState(false);

  const [value, setValue] = React.useState(0);
  const [isDetailsTotalResources, setIsDetailsTotalResources] =
    useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isReady, setIsReady] = useState(false);
  interface CreateTag {
    default?: string[];
    user?: string[];
  }
  const module = useMemo(() => {
    // Find the scan in the Redux list to get the accurate scanType
    const currentScanFromList = myScanDetailsList?.find(
      (s: any) => (s.scan_uuid || s.scan_id || s.id) === paramScanUuid
    );

    let typeFromRedux = "";
    if (currentScanFromList && currentScanFromList.scanType) {
      typeFromRedux = currentScanFromList.scanType.toLowerCase();
    } else if (reduxScanType) {
      typeFromRedux = reduxScanType.toLowerCase();
    }

    if (typeFromRedux) {
      return typeFromRedux.includes("onprem") ? "on_premise" : "cloud";
    }

    // Fallback to pathname logic
    const isOnPrem = location.pathname.includes("on-premises") || location.pathname.includes("onprem/scan");
    return isOnPrem ? "on_premise" : "cloud";
  }, [paramScanUuid, myScanDetailsList, reduxScanType, location.pathname]);

  const [isCreateTag, setIsCreateTags] = useState<CreateTag>({});
  const [isCreateTagClicked, setIsCreateTagClicked] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterDevices, setFilterDevices] = useState<ScanFilterDevice[]>([]);
  const [selectedDevices, setSelectedDevices] = useState<ScanFilterDevice[]>([]);
  const [draftDevices, setDraftDevices] = useState<ScanFilterDevice[]>([]);
  const [devicesLoading, setDevicesLoading] = useState(false);
  const [deviceFilterAnchor, setDeviceFilterAnchor] = useState<HTMLElement | null>(null);
  const [deviceFilterSearch, setDeviceFilterSearch] = useState("");

  const selectedDeviceIds = useMemo(
    () => selectedDevices.map((d) => d.device_id).filter(Boolean),
    [selectedDevices]
  );

  const filteredDeviceOptions = useMemo(() => {
    const q = deviceFilterSearch.trim().toLowerCase();
    if (!q) return filterDevices;
    return filterDevices.filter((d) =>
      [d.hostname, d.vendor, d.model, d.device_type, d.device_id]
        .filter(Boolean)
        .some((v) => v.toLowerCase().includes(q))
    );
  }, [filterDevices, deviceFilterSearch]);

  const dispatch = useDispatch();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    dispatch(setTabSelected(newValue));
  };

  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  console.log(selectedRow, "selectedRow");
  console.log(headerResponse, "headerResponse");

  console.log(value);

  const formik = useFormik({
    initialValues: {
      create_tag: "",
    },
    onSubmit: async (values) => {
      await axiosInstance
        .post("securityscan/create-tag", {
          tag_name: values.create_tag,
          parent_id: null,
          parameter_name_id: selectedRow.id,
        })
        .then((response) => {
          console.log(response.data, "response.data");
          toast(response?.data?.message, { type: "success" });
          formik.resetForm();
          setIsCreateTagClicked(false);
          fetchControlDetails();
          fetchData();
        })
        .catch((error) => {
          console.log(error, "error");
          toast(error?.response?.data?.message || "Something went wrong", {
            type: "error",
          });
        });
    },
  });

  const formatControlRows = (controls: any[]) =>
    controls.map((control: any) => ({
      id: control.id,
      controls: `${control.param_name}`,
      asset_count: control.asset_count,
      compliance_passed_count: control.passed_asset_count,
      compliance_failed_count: control.compliance_failed_count,
      accepted_count: control.accepted_count,
      compliance_count: control.asset_passed_percent,
      tag_name: control.tag_name,
      parameter_type: control.parameter_type,
      is_manual: control.is_manual,
      severity: control.highest_priority,
      control_type: control.control_type,
      total_Count: control.total_asset_count,
      failed_asset_count: control.failed_asset_count,
      passed_asset_count: control.passed_asset_count,
      not_applicable_asset_count: control.not_applicable_asset_count,
    }));

  const buildSummaryDetailsUrl = useCallback(
    (scanId: string, deviceIds: string[] = selectedDeviceIds) => {
      const params = new URLSearchParams({
        scan_summary_id: scanId,
        module: module || "",
      });
      if (deviceIds.length > 0) {
        params.set("device_ids", deviceIds.join(","));
      }
      return `securityscan/scan-summary-details?${params.toString()}`;
    },
    [module, selectedDeviceIds]
  );

  const fetchData = async (deviceIds: string[] = selectedDeviceIds) => {
    if (!scan_summary_id || !module) return;
    setIsLoading(true);
    setIsReady(false);
    try {
      const response = await axiosInstance.get(
        buildSummaryDetailsUrl(scan_summary_id, deviceIds)
      );

      if (response.data?.data && response.data.data.length > 0) {
        const formattedData = formatControlRows(response.data.data);
        setRowData(formattedData);
        setIsReady(true);
      } else {
        setRowData([]);
        setIsReady(true);
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setRowData([]);
      setIsLoading(false);
      setIsReady(true);
    }
  };

  const globalFetchData = async (scanID: any) => {
    setIsLoading(true);
    setIsReady(false);
    try {
      const response = await axiosInstance.get(
        buildSummaryDetailsUrl(scanID, selectedDeviceIds)
      );
      if (response.data?.data) {
        const formattedData = formatControlRows(response.data.data);
        setRowData(formattedData);
        setIsReady(true);
      } else {
        setRowData([]);
        setIsReady(true);
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setRowData([]);
      setIsLoading(false);
      setIsReady(true);
    }
  };

  const fetchFilterDevices = useCallback(async (): Promise<ScanFilterDevice[]> => {
    if (!scan_summary_id || !module) return [];
    setDevicesLoading(true);
    try {
      const response = await axiosInstance.post(
        "securityscan/scan-summary-details",
        {
          action: "list_devices",
          scan_summary_id,
          module,
        }
      );
      const devices: ScanFilterDevice[] = (response.data?.data || [])
        .map((d: any) => ({
          device_id: String(d.device_id || ""),
          hostname: d.hostname || d.host_name || "",
          vendor: d.vendor || "",
          model: d.model || "",
          device_type: d.device_type || "",
        }))
        .filter((d: ScanFilterDevice) => d.device_id);
      setFilterDevices(devices);
      return devices;
    } catch (error) {
      console.error("Error fetching scan devices:", error);
      setFilterDevices([]);
      return [];
    } finally {
      setDevicesLoading(false);
    }
  }, [scan_summary_id, module]);

  //Scan Details API
  useEffect(() => {
    initialFilterAppliedRef.current = false;
    setSelectedDevices([]);
    setDraftDevices([]);
    setIsReady(false);
    if (scan_uuid && module) {
      dispatch(setEdit({
        edit: true,
        scan_uuid,
        status: reduxStatus,
        scanTime: reduxScanTime,
        scanType: reduxScanType,
        onprem_posture_id: queryScanSummaryId || scanSummaryId || reduxPostureId
      }));

      const boot = async () => {
        const devices = await fetchFilterDevices();
        const pendingIds = initialDeviceIds;
        if (pendingIds.length > 0) {
          const matched = devices.filter((d) =>
            pendingIds.includes(d.device_id)
          );
          // Prefer matched list_devices rows; fall back to id-only stubs
          // so the summary still filters even if enrichment is empty.
          const nextSelected =
            matched.length > 0
              ? matched
              : pendingIds.map((id) => ({
                  device_id: id,
                  hostname: "",
                  vendor: "",
                  model: "",
                  device_type: "",
                }));
          setSelectedDevices(nextSelected);
          setDraftDevices(nextSelected);
          initialFilterAppliedRef.current = true;
          await fetchData(pendingIds);
        } else {
          await fetchData([]);
        }
      };
      boot();
    } else if (!scan_uuid) {
      console.error("scan_uuid is undefined");
    }
  }, [scan_uuid, scan_summary_id, module]);

  useEffect(() => {
    const handleFilterSaved = () => {
      setRowData([]);
      globalFetchData(scan_summary_id);
    };

    eventEmitter.on("filterSaved", handleFilterSaved);
    return () => {
      eventEmitter.off("filterSaved", handleFilterSaved);
    };
  }, []);

  // Header Details API
  const fetchControlDetails = () => {
    if (selectedRow) {
      setIsHeaderLoading(true);
      axiosInstance
        .get(`securityscan/control-details/${selectedRow.id}`)
        .then((response) => {
          setHeaderResponse(response.data?.data);
          setIsCreateTags(response.data?.data?.tags);
          setIsHeaderLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching details:", error);
          setIsHeaderLoading(false);
        });
    }
  };

  useEffect(() => {
    fetchControlDetails();
  }, [selectedRow]);

  console.log(isCreateTag, "isCreateTag");

  console.log(headerResponse, "headerResponseheaderResponse");

  //Details >>  Total Resources APi
  useEffect(() => {
    if (selectedRow) {
      axiosInstance
        .get(
          `securityscan/control-asset-details-myscans/${selectedRow.id}?module=${module}&scan_summary_id=${scan_summary_id}`
        )
        .then((response: any) => setIsDetailsTotalResources(response.data))
        .catch((error: any) => console.error("Error fetching details:", error));
    }
  }, [selectedRow]);

  const Total_Resources = isDetailsTotalResources?.data;

  console.log(Total_Resources, "Total_Resources");

  useEffect(() => {
    if (selectedRow?.id) {
      setValue(0);
      dispatch(setTabSelected(0));
      setShowLogOutput(false);
      setIsJuniperVendor(false);
    }
  }, [selectedRow?.id]);

  const handleOnRowClick = (row: any) => {
    setSelectedRow(row);
    setIsRowClick(true);
    setValue(0);
    dispatch(setTabSelected(0));
    dispatch(setSelectedRowID(row.id));
    if (row?.control_type) {
      dispatch(setButtonSelected(row.control_type.toLowerCase()));
    }
    setShowLogOutput(false);
    setIsJuniperVendor(false);
  };
  const agGridInlineStyles = useMemo(
    () => ({
      padding: "0px",
      "& .ag-root": {
        fontSize: "12px",
      },
      "& .ag-header": {
        padding: "0px",
        minHeight: "32px",
      },
      "& .ag-header-cell": {
        padding: "4px 8px !important",
        lineHeight: "1.2",
      },
      "& .ag-row": {
        height: "28px !important",
      },
      "& .ag-cell": {
        padding: "2px 8px !important",
        lineHeight: "1.2",
      },
      "& .ag-center-cols-clipper": {
        marginRight: 0,
      },
      "& .ag-center-cols-viewport": {
        marginRight: 0,
      },
    }),
    []
  );
  const columnDefs: ColDef[] = [
    {
      field: "id",
      headerName: "#",
      minWidth: 70,
      width: 70,
      maxWidth: 70,
      sortable: false,
      filter: false,
      valueGetter: (params: any) => params.node.rowIndex + 1,
    },

    {
      field: "controls",
      headerName: "Recommendation",
      filter: true,
      minWidth: 450,
      width: 450,
      flex: 1,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      cellRenderer: (params: any) => {
        const value = params.value || "";
        const parameterType = params.data?.parameter_type || "";
        const isManual = parameterType === "Manual";
        // const color = isManual ? "#F7941F" : "#696595";
        const color = isManual
          ? isDarkMode
            ? "#FFB74D"
            : "#F7941F"
          : isDarkMode
            ? "#B2B2FF"
            : "#696595";
        const bgcolor = isManual ? "#F7941F" : "#696595";

        return (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "minmax(0, 1fr) 100px",
              alignItems: "center",
              width: "100%",
              gap: 16,
            }}
          >
            <WhiteTooltip title={value}>
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontWeight: "bold",
                }}
              >
                {value}
              </Typography>
            </WhiteTooltip>
            <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
              {parameterType && (
                <Chip
                  label={parameterType}
                  variant="outlined"
                  size="small"
                  sx={{
                    borderRadius: 1,
                    border: `1px solid ${bgcolor}`,
                    // bgcolor: "white",
                    color: color,
                    fontWeight: "bold",
                  }}
                />
              )}
            </Box>
          </div>
        );
      },
    },

    {
      field: "tag_name",
      headerName: "Tags",
      filter: true,
      minWidth: 240,
      cellRenderer: (params: any) => {
        const getRandomColor = () => {
          const hue = Math.floor(Math.random() * 360);
          return {
            background: `hsl(${hue}, 70%, 80%)`,
            color: `hsl(${hue}, 50%, 20%)`,
          };
        };

        const tagString = params.data?.tag_name;
        const tagsArray = tagString.split(",").map((tag: any) => tag.trim());

        const visibleTags = tagsArray.slice(0, 1);
        const hiddenTags = tagsArray.slice(1);

        // Capitalize first letter utility
        const capitalize = (str: string) =>
          str.charAt(0).toUpperCase() + str.slice(1);

        return (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
            {visibleTags.map((tag: string, index: number) => {
              // Apply specific styles to first and second tag
              let style = {};
              if (index === 0) {
                style = {
                  backgroundColor: "#0183191A",
                  color: "#018319",
                };
              } else if (index === 1) {
                style = {
                  backgroundColor: "#894B001A",
                  color: "#894B00",
                };
              } else {
                const random = getRandomColor();
                style = {
                  backgroundColor: random.background,
                  color: random.color,
                };
              }

              return (
                <Chip
                  key={index}
                  size="small"
                  label={capitalize(tag)}
                  style={{
                    ...style,
                    fontWeight: "bold",
                    borderRadius: 4,
                  }}
                />
              );
            })}

            {hiddenTags.length > 0 && (
              <WhiteTooltip title={hiddenTags.join(", ")} arrow placement="top">
                <Chip
                  size="small"
                  variant="outlined"
                  label={`+${hiddenTags.length}`}
                  style={{
                    fontWeight: "bold",
                    borderRadius: 4,
                    border: "1px solid #BEBED1",
                  }}
                />
              </WhiteTooltip>
            )}
          </div>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },

    {
      field: "control_type",
      headerName: "Benchmark",
      filter: true,
      minWidth: 150,
      width: 200,
      cellClass: "custom-cell", // Add this class for custom alignment
      cellRenderer: (params: any) => {
        if (!params.value) return null;

        const rawParts: string[] = Array.isArray(params.value)
          ? params.value
          : String(params.value)
              .split(",")
              .map((item: string) => item.trim())
              .filter(Boolean);

        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, pt: 1, flexWrap: "nowrap" }}>
            {rawParts.map((part: string, index: number) => {
              const partTrimmed = part.trim();
              const partUpper = partTrimmed.toUpperCase();

              const isSpark = partUpper === "SPARK" || (partUpper.startsWith("SPARK ") && !partUpper.startsWith("SPARK_"));
              const isCis = partUpper === "CIS" || (partUpper.startsWith("CIS ") && !partUpper.startsWith("CISCO"));
              const isNist = partUpper === "NIST" || partUpper.startsWith("NIST ");

              if (isSpark) {
                return (
                  <img
                    key={index}
                    src={isDarkMode ? spark_dark : sparkLogo}
                    alt="spark"
                    height="24"
                  />
                );
              }
              if (isCis) {
                return (
                  <img
                    key={index}
                    src={isDarkMode ? cis_dark : csiLogo}
                    alt="cis"
                    height="24"
                  />
                );
              }
              if (isNist) {
                return (
                  <img
                    key={index}
                    src={isDarkMode ? nist_dark : nistLogo}
                    alt="nist"
                    height="12"
                  />
                );
              }
              return (
                <Tooltip
                  key={index}
                  title={partTrimmed}
                  arrow
                  placement="top"
                >
                  <img
                    src={customTemplateLogo}
                    alt="Custom Template"
                    height="24"
                  />
                </Tooltip>
              );
            })}
          </Box>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },

    {
      field: "severity",
      headerName: "Severity",
      filter: true,
      minWidth: 150,
      width: 200,
      cellRenderer: (params: any) => {
        const severityStyles: any = {
          Critical: { bgcolor: isDarkMode ? "rgba(255, 61, 61, 0.18)" : "#67000424", color: isDarkMode ? "#FF3D3D" : "#670004" },
    High: { bgcolor: isDarkMode ? "rgba(255, 107, 107, 0.15)" : "#A7000F24", color: isDarkMode ? "#FF6B6B" : "#A7000F" },
    Medium: { bgcolor: isDarkMode ? "rgba(255, 167, 38, 0.15)" : "#E8580024", color: isDarkMode ? "#FFA726" : "#E85800" },
    Low: { bgcolor: isDarkMode ? "rgba(255, 224, 130, 0.15)" : "#F2BF0024", color: isDarkMode ? "#FFE082" : "#F2BF00" },
  };
        return (
          <Chip
            label={params.value}
            size="small"
            sx={{
              bgcolor: severityStyles[params.value]?.bgcolor || "#f5f5f5",
              color: severityStyles[params.value]?.color || "#666666",
              height: "20px",
              borderRadius: "4px",
              position: "relative",
              fontWeight: 600,
              p: 1.5,
              pr: 0,
              "&::before": {
                content: '""',
                position: "absolute",
                left: 8,
                top: "50%",
                transform: "translateY(-50%)",
                width: 8,
                height: 8,
                bgcolor: severityStyles[params.value]?.color || "#666666",
                borderRadius: "50%",
              },
              "& .MuiChip-label": { px: 1 },
            }}
          />
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      field: "accepted_count",
      headerName: "Risk Accepted",
      filter: true,
      minWidth: 150,
      cellRenderer: (params: any) =>
        params.value > 0 ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, pt: 1 }}>
            <img src={Exclamation} alt="exclamation" height="20" />
            <Typography>{params.value}</Typography>
          </Box>
        ) : (
          <img
            src={AcceptedRisk_False}
            alt="warning"
            style={{ height: "20px" }}
          />
        ),
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    {
      field: "compliance_count",
      headerName: module === "on_premise" ? "Assets" : "Resources",
      minWidth: 200, cellRenderer: (params: any) => {
        const passedCount = params.data.compliance_passed_count;
        const compliance_count = params.data.total_Count;
        const rawValue = params.value || 0;
        const data = params.data;
        const progressValue = Number(rawValue.toFixed(2));
        const STATUS_CONFIG = {
          passed_asset_count: { label: "Pass", icon: True },
          failed_asset_count: { label: "Fail", icon: False },
          not_applicable_asset_count: {
            label: "Not Applicable",
            icon: Not_Applicable,
          },
        };
        const availableStatuses = Object.entries(STATUS_CONFIG)
          .filter(([key]) => data[key] != null && data[key] > 0)
          .map(([key, config]) => ({
            ...config,
            count: data[key],
            key,
          }));

        const total = availableStatuses.reduce((sum, s) => sum + s.count, 0);
        const passed = data.passed_asset_count || 0;
        const passPercent =
          total > 0 ? ((passed / total) * 100).toFixed(2) : "0.00";

        const tooltipContent =
          availableStatuses.length > 0 ? (
            <Box sx={{ p: 1, width: 200 }}>
              {availableStatuses.map((status) => (
                <Box
                  key={status.key}
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
                >
                  <img
                    src={status.icon}
                    alt={status.label}
                    style={{ width: 20, height: 20 }}
                  />
                  <Typography
                    variant="body2"
                    fontWeight={500}
                    sx={{ flexGrow: 1, color: "#000" }}
                  >
                    {status.label}
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ color: "#000" }}>
                    {status.count}
                  </Typography>
                </Box>
              ))}
            </Box>
          ) : (
            <Box sx={{ p: 1 }}>
              <Typography variant="body2" sx={{ color: "#000" }}>No data available</Typography>
            </Box>
          );

        return (
          <Tooltip
            title={tooltipContent}
            arrow
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: "preventOverflow",
                    options: {
                      boundary: "window",
                    },
                  },
                ],
              },
              tooltip: {
                sx: {
                  backgroundColor: "#fff",
                  color: "#000",
                  border: "1px solid #ddd",
                  boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                  fontSize: "14px",
                },
              },
              arrow: {
                sx: {
                  color: "#fff",
                },
              },
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0.5,
                }}
              >
                <Typography variant="caption">
                  {`${passedCount}/${compliance_count} (${progressValue}%)`}
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={progressValue}
                sx={{
                  height: 6,
                  borderRadius: 3,
                  bgcolor: "#f5f5f5",
                  "& .MuiLinearProgress-bar": {
                    bgcolor:
                      progressValue >= 70
                        ? "#4caf50"
                        : progressValue >= 40
                          ? "#ff9800"
                          : "#f44336",
                  },
                }}
              />
            </Box>
          </Tooltip>
        );
      },
    },
  ];

  const getSeverityStyle = (severity: string) => {
    switch (severity?.toLowerCase()) {
      case "low":
        return { color: "#F2BF00", backgroundColor: "#F2BF0024" };
      case "high":
        return { color: "#A7000F", backgroundColor: "#A7000F24" };
      case "critical":
        return { color: "#670004", backgroundColor: "#67000424" };
      case "medium":
        return { color: "#E85800", backgroundColor: "#E8580024" };
      default:
        return { color: "gray", backgroundColor: "#E0E0E0" };
    }
  };
  const Chipstyle = getSeverityStyle(headerResponse?.severity);

  const TypeChipColor = (type: string) => {
    switch (type) {
      case "Manual":
        return { color: "#2B335F", bgcolor: "#DEDDF2" };
      case "Automated":
        return { color: "#0B3D2E", bgcolor: "#CFF3E0" };
      default:
        return { color: "#000", bgcolor: "#E0E0E0" }; // fallback color
    }
  };

  const getTagStyle = (tag: string) => {
    switch (tag?.toLowerCase()) {
      case "ssh":
        return { color: "#018319", backgroundColor: "#0183191A" }; // Red tones
      case "https":
        return { color: "#894B00", backgroundColor: "#894B001A" }; // Green tones
      case "authentication":
        return { color: "#0485C2", backgroundColor: "#0485C21A" }; // Blue tones
      default:
        return { color: "gray", backgroundColor: "#E0E0E0" }; // Default gray
    }
  };

  const getStyledTag = (tag: string, index: number) => {
    const styles = [
      { color: "#018319", backgroundColor: "#0183191A" }, // green
      { color: "#894B00", backgroundColor: "#894B001A" }, // brown
      { color: "#0485C2", backgroundColor: "#0485C21A" },
      { color: "#3A2ADA", backgroundColor: "#1103C014" }, // blue
      { color: "gray", backgroundColor: "#E0E0E0" }, // gray
    ];

    const style = styles[index] || {
      color: "black",
      backgroundColor: "#f0f0f0",
    };

    // Ellipsis logic: if tag length > 10, show first 7 chars + ...
    let displayTag = tag;
    if (tag.length > 10) {
      displayTag = tag.slice(0, 7) + "...";
    }

    return (
      <WhiteTooltip title={tag} arrow >

        <span style={{ cursor: "default" }}>
          <Chip
            key={index}
            label={displayTag}
            style={style}
            sx={{ borderRadius: 1, fontWeight: "bold" }}
            size="small"
          />
        </span>
      </WhiteTooltip>
    );
  };

  // Show user-created tags first so newly created tags appear at the top
  const allTags = [
    ...(headerResponse?.tags?.user || []),
    ...(headerResponse?.tags?.default || []),
  ];

  const visibleTags = allTags.slice(0, 3);
  const hiddenTags = allTags.slice(3);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    console.log("Anchor Element:", event.currentTarget); // Debugging
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setSearchQuery("");
    setIsCreateTagClicked(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;

  const [showLogOutput, setShowLogOutput] = useState(false);
  const [logOutputData, setLogOutputData] = useState<any>(null);
  const [logOutputRowData, setLogOutputRowData] = useState<any>(null);
  const [isJuniperVendor, setIsJuniperVendor] = useState(false);

  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => {
    setIsHovered(false);
    setIsClicked(false); // Optional: reset clicked on mouse leave
  };

  const getImage = () => {
    if (isHovered || open) return Pencil_Blue;
    return Pencil_Light_img;
  };

  const applyDeviceSelection = (next: ScanFilterDevice[]) => {
    setSelectedDevices(next);
    fetchData(next.map((d) => d.device_id).filter(Boolean));
  };

  const toggleDraftDevice = (device: ScanFilterDevice) => {
    setDraftDevices((prev) => {
      const exists = prev.some((d) => d.device_id === device.device_id);
      return exists
        ? prev.filter((d) => d.device_id !== device.device_id)
        : [...prev, device];
    });
  };

  const openDeviceFilter = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setDraftDevices(selectedDevices);
    setDeviceFilterSearch("");
    setDeviceFilterAnchor(e.currentTarget);
  };

  const closeDeviceFilter = () => {
    setDeviceFilterAnchor(null);
    setDeviceFilterSearch("");
    setDraftDevices(selectedDevices);
  };

  const handleApplyDeviceFilter = () => {
    applyDeviceSelection(draftDevices);
    setDeviceFilterAnchor(null);
    setDeviceFilterSearch("");
  };

  const clearDraftDeviceFilter = () => {
    setDraftDevices([]);
  };

  const deviceFilterOpen = Boolean(deviceFilterAnchor);

  const handleScanInformationClick = () => {
    const summaryId = scan_summary_id || scan_uuid;
    if (!scan_uuid || !summaryId) return;

    const isCloud =
      module === "cloud" || location.pathname.includes("/cloud/");
    const infoPath = isCloud
      ? `/cloud/scan-details/${scan_uuid}`
      : `/on-premises/scan-details/${scan_uuid}`;

    dispatch(
      setEdit({
        edit: true,
        scan_uuid,
        status: reduxStatus,
        scanTime: reduxScanTime,
        scanType: reduxScanType,
        onprem_posture_id: summaryId,
      })
    );

    navigate(infoPath);
  };

  const deviceFilterAdornment = (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, pr: 0.5 }}>
      <Button
        variant="contained"
        size="small"
        onClick={handleScanInformationClick}
        sx={{ textTransform: "none", whiteSpace: "nowrap" }}
      >
        Scan Information
      </Button>
      <Tooltip title="Filter by device">
        <IconButton
          size="small"
          aria-label="Filter by device"
          onClick={openDeviceFilter}
          sx={{
            color:
              selectedDeviceIds.length > 0
                ? "primary.main"
                : "text.secondary",
          }}
        >
          <Badge
            color="primary"
            badgeContent={selectedDeviceIds.length || undefined}
            max={99}
          >
            <FilterAltOutlinedIcon fontSize="small" />
          </Badge>
        </IconButton>
      </Tooltip>
      <Popover
        open={deviceFilterOpen}
        anchorEl={deviceFilterAnchor}
        onClose={closeDeviceFilter}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            width: 340,
            maxHeight: 460,
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <Box sx={{ px: 1.5, pt: 1.5, pb: 1 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1,
            }}
          >
            <Typography variant="subtitle2">Filter by device</Typography>
            <Button
              size="small"
              onClick={clearDraftDeviceFilter}
              disabled={draftDevices.length === 0}
              sx={{ textTransform: "none", minWidth: 0 }}
            >
              Clear
            </Button>
          </Box>
          <TextField
            size="small"
            fullWidth
            placeholder="Search devices"
            value={deviceFilterSearch}
            onChange={(e) => setDeviceFilterSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ mt: 0.75, display: "block" }}
          >
            {draftDevices.length === 0
              ? "All devices"
              : `${draftDevices.length} selected`}
          </Typography>
        </Box>
        <Divider />
        <Box sx={{ overflow: "auto", flex: 1 }}>
          {devicesLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
              <CircularProgress size={22} />
            </Box>
          ) : filteredDeviceOptions.length === 0 ? (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ px: 2, py: 2 }}
            >
              No devices found
            </Typography>
          ) : (
            <List dense disablePadding>
              {filteredDeviceOptions.map((device) => {
                const checked = draftDevices.some(
                  (d) => d.device_id === device.device_id
                );
                const secondary = [device.vendor, device.model, device.device_type]
                  .filter(Boolean)
                  .join(" · ");
                return (
                  <ListItemButton
                    key={device.device_id}
                    onClick={() => toggleDraftDevice(device)}
                    dense
                  >
                    <ListItemIcon sx={{ minWidth: 36 }}>
                      <Checkbox
                        edge="start"
                        size="small"
                        checked={checked}
                        tabIndex={-1}
                        disableRipple
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={device.hostname || device.device_id}
                      secondary={secondary || undefined}
                      primaryTypographyProps={{ variant: "body2" }}
                      secondaryTypographyProps={{ variant: "caption" }}
                    />
                  </ListItemButton>
                );
              })}
            </List>
          )}
        </Box>
        <Divider />
        <Box
          sx={{
            px: 1.5,
            py: 1,
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
          <Button
            size="small"
            onClick={closeDeviceFilter}
            sx={{ textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={handleApplyDeviceFilter}
            sx={{ textTransform: "none" }}
          >
            Apply
          </Button>
        </Box>
      </Popover>
    </Box>
  );

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          height: "100%",
          borderRadius: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <AgGridTable
          columnDefs={columnDefs}
          styles={agGridInlineStyles}
          data={rowData}
          showSearch
          isRowSelectable
          height={"100%"}
          onRowClick={handleOnRowClick}
          isLoading={!isReady || isLoading}
          headerActions={deviceFilterAdornment}
        />
      </Card>
      <Drawer
        anchor="right"
        open={isRowClick}
        onClose={() => {
          setIsRowClick(false);
          setShowLogOutput(false);
          setIsJuniperVendor(false);
          setValue(0);
          dispatch(setTabSelected(0));
        }}
        sx={{
          "& .MuiDrawer-paper": {
            // width: 700,
            width: "50%",
            // height: "calc(110vh - 100px)",
            overflow: "hidden",
            // borderRadius: "10px",
            // mt: 1,
            // mr: 1,
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <Box
          sx={{
            padding: 2,
            borderBottom: 1,
            borderColor: "divider",
            position: "sticky",
            top: 0,
            zIndex: 10,
          }}
        >
          <Box sx={{ position: "relative" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 3,
              }}
            >
              {isHeaderLoading ? (
                <Skeleton variant="text" width={300} height={32} sx={{ fontWeight: "bold" }} />
              ) : (
                <Typography variant="h6" width={710} sx={{ fontWeight: "bold" }}>
                  {headerResponse?.normalized_name}
                </Typography>
              )}
            </div>

            <HighlightOffIcon
              sx={{
                position: "absolute",
                top: -8,   // adjust as needed
                right: -8, // adjust as needed
                color: "#A6A5B6",
                cursor: "pointer",
              }}
              onClick={() => {
                setIsRowClick(false);
                setShowLogOutput(false);
                setIsJuniperVendor(false);
                setValue(0);
                dispatch(setTabSelected(0));
              }}
            />
          </Box>


          {isHeaderLoading ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 5,
                marginBottom: 3,
                alignItems: "center",
              }}
            >
              <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 1 }} />
              <Skeleton variant="rectangular" width={100} height={24} sx={{ borderRadius: 1 }} />
              <Divider orientation="vertical" flexItem />
              <Skeleton variant="text" width={40} height={20} />
              <Skeleton variant="rectangular" width={60} height={24} sx={{ borderRadius: 1 }} />
              <Skeleton variant="rectangular" width={60} height={24} sx={{ borderRadius: 1 }} />
              <Skeleton variant="rectangular" width={25} height={25} sx={{ borderRadius: 1 }} />
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 5,
                marginBottom: 3,
              }}
            >
              <Chip
                icon={
                  <Box
                    sx={{
                      width: 16,
                      height: 16,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: Chipstyle.backgroundColor,
                      borderRadius: "50%",
                    }}
                  >
                    <FiberManualRecordIcon
                      fontSize="inherit"
                      sx={{ color: Chipstyle.color }}
                    />
                  </Box>
                }
                label={headerResponse?.severity}
                size="small"
                sx={{
                  fontWeight: "bold",
                  ...Chipstyle,
                  borderRadius: 1,
                }}
              />
              <WhiteTooltip
                title={
                  headerResponse?.type === "Automated"
                    ? "This recommendation can be analysed automatically. No Manual intervention required."
                    : "This recommendation should be reviewed manually."
                }
                arrow
              >
                <Chip
                  label={headerResponse?.type}
                  sx={{
                    bgcolor: TypeChipColor(headerResponse?.type).bgcolor,
                    color: TypeChipColor(headerResponse?.type).color,
                    height: "20px",
                    borderRadius: 1,
                    minHeight: 24,
                    fontWeight: 600,

                    // 👇 Change here
                    cursor: "default",
                    pointerEvents: "auto",

                    "&:hover": {
                      cursor: "default",
                    },

                    "& .MuiChip-label": {
                      cursor: "default",
                      pointerEvents: "auto",
                    },
                  }}
                  size="small"
                />
              </WhiteTooltip>
              <Divider orientation="vertical" flexItem />
              <Typography
                sx={{ fontWeight: 600, fontSize: "14px", color: "#8787AE" }}
              >
                Tags:
              </Typography>
              <div style={{ display: "flex", flexDirection: "row", gap: 5 }}>
                {visibleTags.map((tag: string, index: number) =>
                  getStyledTag(
                    tag.charAt(0).toUpperCase() + tag.slice(1), // Capitalize first letter
                    index
                  )
                )}

                {hiddenTags.length > 0 && (
                  <WhiteTooltip
                    title={hiddenTags
                      .map((tag) => tag.charAt(0).toUpperCase() + tag.slice(1))
                      .join(", ")}
                    arrow
                    placement="bottom"
                  >
                    <div
                      style={{
                        backgroundColor: "#ccc",
                        borderRadius: "50%",
                        width: 28,
                        height: 28,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "bold",
                        fontSize: 13,
                        cursor: "pointer",
                      }}
                    >
                      +{hiddenTags.length}
                    </div>
                  </WhiteTooltip>
                )}
              </div>
              <div>
                <img
                  src={getImage()}
                  alt="edit"
                  style={{ cursor: "pointer", width: "25px", marginLeft: 10 }}
                  onClick={handleClick}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                />

                <Popper
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  disablePortal
                  sx={{ boxShadow: 1 }}
                  modifiers={[
                    {
                      name: "offset",
                      options: {
                        offset: [0, 10],
                      },
                    },
                  ]}
                >
                  {" "}
                  {isCreateTagClicked ? (
                    <form onSubmit={formik.handleSubmit}>
                      <Box sx={{ bgcolor: "background.paper", p: 1 }}>
                        <Typography
                          variant="body2"
                          fontWeight="700"
                          sx={{ mb: 1 }}
                        >
                          Create Tag
                        </Typography>
                        <TextField
                          variant="outlined"
                          sx={{ mb: 2 }}
                          placeholder="Create Tag"
                          id="create_tag"
                          name="create_tag"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          value={formik.values.create_tag}
                          required
                        />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Button
                            variant="outlined"
                            sx={{ width: 90 }}
                            onClick={() => setIsCreateTagClicked(false)}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="contained"
                            sx={{ width: 100 }}
                            type="submit"
                            disabled={!formik.dirty || !formik.isValid || formik.isSubmitting}
                          >
                            Create {formik.isSubmitting && <CircularProgress size={16} color="inherit" sx={{ ml: 1 }} />}
                          </Button>
                        </div>
                      </Box>
                    </form>
                  ) : (
                    <Box sx={{ p: 1, bgcolor: "background.paper" }}>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        placeholder="Search"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        sx={{
                          mb: 1,
                          color: "#E9E9F8",
                          backgroundClip: "#E9E9F8",
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                      />{" "}
                      <Divider sx={{ color: "#D2D2F6" }} />
                      <div
                        style={{
                          display: "flex",
                          gap: 5,
                          marginTop: 10,
                          marginBottom: 10,
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={Plus_Blue_img}
                          alt=""
                          style={{ width: 30, cursor: "pointer" }}
                          onClick={() => setIsCreateTagClicked(true)}
                        />
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#3A2ADA",
                            fontSize: "16px",
                            fontWeight: 700,
                            cursor: "pointer",
                          }}
                          onClick={() => setIsCreateTagClicked(true)}
                        >
                          Create Tag
                        </Typography>
                      </div>
                      <Divider sx={{ color: "#D2D2F6" }} />
                      <div>
                        {/* User Tags - show first so newly created tags appear at top */}
                        <Box
                          display="flex"
                          flexDirection="column"
                          gap="0.5rem"
                          mb={isCreateTag?.default?.length ? 2 : 0}
                        >
                          {isCreateTag?.user && isCreateTag.user.filter(tag => tag.toLowerCase().includes(searchQuery.toLowerCase())).length > 0 ? (
                            isCreateTag.user.filter(tag => tag.toLowerCase().includes(searchQuery.toLowerCase())).map((tag: string, index: number) => (
                              <Tooltip
                                key={`user-tooltip-${index}`}
                                title={tag.length > 10 ? tag : ""}
                                arrow
                                slotProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#fff",
                                      color: "#000",
                                      boxShadow: 1,
                                      fontSize: "0.875rem",
                                    },
                                  },
                                  arrow: {
                                    sx: {
                                      color: "#fff",
                                    },
                                  },
                                }}
                              >
                                <Typography
                                  key={`user-${index}`}
                                  variant="body2"
                                  sx={{
                                    fontWeight: 700,
                                    fontSize: "16px",
                                    color: "#6D738F",
                                    maxWidth: "150px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    cursor: tag.length > 10 ? "pointer" : "default",
                                  }}
                                >
                                  {tag}
                                </Typography>
                              </Tooltip>
                            ))
                          ) : (
                            <div></div>
                          )}
                        </Box>

                        {/* Default Tags - show after user tags */}
                        <Box display="flex" flexDirection="column" gap="0.5rem">
                          {isCreateTag?.default && isCreateTag.default.filter(tag => tag.toLowerCase().includes(searchQuery.toLowerCase())).length > 0 ? (
                            isCreateTag.default.filter(tag => tag.toLowerCase().includes(searchQuery.toLowerCase())).map((tag: string, index: number) => (
                              <Tooltip
                                key={`default-tooltip-${index}`}
                                title={tag.length > 10 ? tag : ""}
                                arrow
                                slotProps={{
                                  tooltip: {
                                    sx: {
                                      backgroundColor: "#fff",
                                      color: "#000",
                                      boxShadow: 1,
                                      fontSize: "0.875rem",
                                    },
                                  },
                                  arrow: {
                                    sx: {
                                      color: "#fff",
                                    },
                                  },
                                }}
                              >
                                <Typography
                                  key={`default-${index}`}
                                  variant="body2"
                                  sx={{
                                    fontWeight: 700,
                                    fontSize: "16px",
                                    color: "#6D738F",
                                    maxWidth: "150px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    cursor: tag.length > 10 ? "pointer" : "default",
                                  }}
                                >
                                  {tag}
                                </Typography>
                              </Tooltip>
                            ))
                          ) : (
                            <div></div>
                          )}
                        </Box>
                      </div>
                    </Box>
                  )}
                </Popper>
              </div>{" "}
            </div>
          )}
        </Box>

        {/* {showLogOutput?():()} */}

        <Box sx={{ flexGrow: 1, overflowY: "auto" }} className="scroll">
          {showLogOutput ? (
            (isJuniperVendor && selectedRow?.is_manual === true) ? (
              // <LogoutputManual
              //   rowData={logOutputRowData}
              //   parameter_name_id={selectedRow.id}
              //   onBack={() => setShowLogOutput(false)}
              //   module={module}
              // />
              <Logoutput
                // status={logOutputData?.compliance || "Fail"}
                // acceptedRisk={logOutputData?.acceptedRisk || true}
                // lastScanned={logOutputData?.lastScanned || "03 May,2025"}
                analysis={
                  logOutputData?.analysis || [
                    {
                      ruleName: "Anti-Virus Profile do the Rule RULE-NAME-1",
                      status: "failed",
                      final_output: true,
                      message: "Anti-Virus Profile is not set for the rule.",
                    },
                    {
                      ruleName: "Anti-Virus Profile do the Rule RULE-NAME-2",
                      status: "passed",
                      final_output: false,
                      message:
                        "Anti-Virus Profile is not required for the rule if action is not allow.",
                    },
                    {
                      ruleName: "Scan Analysis",
                      status: "failed",
                      final_output: false,

                      message:
                        "Anti-Virus profile AV-PROFILE-1 is set for the rule.",
                      output: [
                        "FAILED. NO rules found for the Anti-Spyware profile 'Exception-AS'",
                        "FAILED. Anti-Spyware Profile 'Alert-Only-AS' using rule 'Alert-All' does not meets all criteria.",
                        "FAILED. Anti-Spyware Profile 'Internal-AS' using rule 'Block-Critical-High' does not meets all criteria.",
                        "FAILED. Anti-Spyware Profile 'Internal-AS' using rule 'Default-Medium-Low-Info' does not meets all criteria.",
                        "FAILED. Anti-Spyware Profile 'Inbound-AS' using rule 'Block-Critical-High-Medium' does not meets all criteria.",
                        "FAILED. Anti-Spyware Profile 'Inbound-AS' using rule 'Default-Low-Info' does not meets all criteria.",
                        "FAILED. Anti-Spyware Profile 'Outbound-AS' using rule 'Block-Critical-High-Medium' does not meets all criteria.",
                      ],
                    },
                  ]
                } rowData={logOutputRowData}
                parameter_name_id={selectedRow.id}
                onBack={() => setShowLogOutput(false)}
                parameterType={selectedRow?.parameter_type}
              />
            ) : (
              <Logoutput
                // status={logOutputData?.compliance || "Fail"}
                // acceptedRisk={logOutputData?.acceptedRisk || true}
                // lastScanned={logOutputData?.lastScanned || "03 May,2025"}
                analysis={
                  logOutputData?.analysis || [
                    {
                      ruleName: "Anti-Virus Profile do the Rule RULE-NAME-1",
                      status: "failed",
                      final_output: true,
                      message: "Anti-Virus Profile is not set for the rule.",
                    },
                    {
                      ruleName: "Anti-Virus Profile do the Rule RULE-NAME-2",
                      status: "passed",
                      final_output: false,
                      message:
                        "Anti-Virus Profile is not required for the rule if action is not allow.",
                    },
                    {
                      ruleName: "Scan Analysis",
                      status: "failed",
                      final_output: false,

                      message:
                        "Anti-Virus profile AV-PROFILE-1 is set for the rule.",
                      output: [
                        "FAILED. NO rules found for the Anti-Spyware profile 'Exception-AS'",
                        "FAILED. Anti-Spyware Profile 'Alert-Only-AS' using rule 'Alert-All' does not meets all criteria.",
                        "FAILED. Anti-Spyware Profile 'Internal-AS' using rule 'Block-Critical-High' does not meets all criteria.",
                        "FAILED. Anti-Spyware Profile 'Internal-AS' using rule 'Default-Medium-Low-Info' does not meets all criteria.",
                        "FAILED. Anti-Spyware Profile 'Inbound-AS' using rule 'Block-Critical-High-Medium' does not meets all criteria.",
                        "FAILED. Anti-Spyware Profile 'Inbound-AS' using rule 'Default-Low-Info' does not meets all criteria.",
                        "FAILED. Anti-Spyware Profile 'Outbound-AS' using rule 'Block-Critical-High-Medium' does not meets all criteria.",
                      ],
                    },
                  ]
                } rowData={logOutputRowData}
                parameter_name_id={selectedRow.id}
                onBack={() => setShowLogOutput(false)}
                parameterType={selectedRow?.parameter_type}
              />
            )
          ) : (
            <>
              <Box sx={{ position: "sticky", zIndex: 9, overflow: "auto" }}>
                <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    overflow: "auto",
                  }}
                  className="scroll"
                >
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                  >
                    {(() => {
                      const tabsList = [
                        { label: "Assets", index: 0 },
                        { label: "Compliance", index: 1 },
                        { label: "Details", index: 2 },
                      ];
                      
                      let visibleTabs = tabsList;
                      
                      const paramType = selectedRow?.parameter_type?.toLowerCase();
                      if (paramType === "template" || paramType === "custom") {
                        visibleTabs = visibleTabs.filter(tab => tab.label !== "Compliance");
                      }

                      return visibleTabs.map((tab) => (
                        <Tab
                          key={tab.index}
                          value={tab.index}
                          label={
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: "bold",
                                color: value === tab.index ? "#3A2ADA" : "#8787AE",
                              }}
                            >
                              {tab.label}
                            </Typography>
                          }
                          {...a11yProps(tab.index)}
                          sx={{
                            minWidth: 100,
                            "&.Mui-selected": { color: "#3A2ADA" },
                            "&:not(.Mui-selected)": { color: "#8787AE" },
                            textTransform: "none",
                          }}
                        />
                      ));
                    })()}
                  </Tabs>
                </Box>
              </Box>

              <CustomTabPanel value={value} index={0}>
                <AssetsFlyout
                  id={selectedRow?.id}
                  module={module}
                  scanSummaryId={scan_summary_id}
                  parameterType={selectedRow?.parameter_type}
                  deviceIds={selectedDeviceIds}
                  onRowClick={(row: any) => {
                    console.log(row);
                    setShowLogOutput(true);
                    setLogOutputData(null); // Replace with real data fetch if needed
                    setLogOutputRowData(row);
                    // Check if vendor is juniper to determine which component to show
                    setIsJuniperVendor(row.vendor?.toLowerCase() === "juniper");
                  }}
                />
              </CustomTabPanel>
              {!(selectedRow?.parameter_type?.toLowerCase() === "template" || selectedRow?.parameter_type?.toLowerCase() === "custom") && (
                <CustomTabPanel value={value} index={1}>
                  <Compliance id={selectedRow?.id} module={module} />
                </CustomTabPanel>
              )}
              <CustomTabPanel value={value} index={2}>
                <DetailsFlyout
                  Total_Resources={Total_Resources}
                  id={selectedRow?.id}
                  isTotal={true}
                  scanSummaryId={scan_summary_id}
                  module={module}
                  parameterType={selectedRow?.parameter_type}
                  controlType={selectedRow?.control_type}
                />
              </CustomTabPanel>
            </>
          )}
        </Box>
      </Drawer>
    </>
  );
};

export default ScanDetails;
